import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { MainComponent } from "./main.component";
import { FullComponent } from "../layouts/full/full.component";
// import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthGuardMain } from "../auth/auth-guard.service";
import { DashboardComponent } from "./dashboard/dashboard.component";

const routes: Routes = [
  // { path: "", redirectTo: "/main/dashboard", pathMatch: "full" },
  {
    path: "main",
    component: MainComponent,
    canActivate: [AuthGuardMain],
    children: [
      { path: "", redirectTo: "/main/dashboard", pathMatch: "full" },
      // {
      //   path: "dashboard",
      //   component: DashboardComponent,
      // },
      { path: "dashboard", loadChildren: () => import("./dashboard/dashboard.module").then(m => m.DashboardModule) },
      {
        path: "vedio-management",
        loadChildren: () => import("./vedio-managment/vedio-management.module").then(m => m.VedioMngmtModule)
      },
      {
        path: "user-management",
        loadChildren: () => import("../main/user-management/user-management.module").then(m => m.UserManagementModule)
      },
      {
        path: "school-management",
        loadChildren: () =>
          import("../main/school-management/school-management.module").then(m => m.SchoolManagementModule)
      },
      {
        path: "company-management",
        loadChildren: () =>
          import("../main/company-management/company-management.module").then(m => m.CompanyManagementModule)
      },
      {
        path: "general-management",
        loadChildren: () => import("../main/general-list/general-list.module").then(m => m.GeneralListModule)
      },
      { path: "add-company", loadChildren: () => import("../main/company/company.module").then(m => m.CompanyModule) },
      // { path: 'distance-management', loadChildren: () => import('../main/distance/distance.module').then(m => m.DistanceModule)},
      // { path: 'race-management', loadChildren: () => import('../main/race/race.module').then(m => m.RaceModule)},
      // { path: 'rules-management', loadChildren: () => import('../main/rules/rules.module').then(m => m.RulesModule)},
      // { path: 'participant-management', loadChildren: () => import('../main/participant/participant.module').then(m => m.ParticipantModule)},
      {
        path: "setting",
        loadChildren: () =>
          import("../main/setting-management/setting-management.module").then(m => m.SettingManagementModule)
      },
      {
        path: "analytic",
        loadChildren: () =>
          import("../main/analytic-management/analytic-management.module").then(m => m.AnalticManagementModule)
      }
      // { path: 'setting', loadChildren: () => import('../main/setting-management/setting-management.module').then(m => m.SettingManagementModule)},
      // {
      //   path: "setting-management",
      //   component: SettingManagementComponent,
      // },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainRoutingModule {}
